import axios from 'axios';
import { getExpressAPIHost } from '../../utils';

const uploadAssignments = async (year, month, type, formData) => {
    const response = await axios.post(`${getExpressAPIHost()}/assignments/upload-assignments/${year}/${month}/${type}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response;
};
export default uploadAssignments;
